export enum WheelAction {
    AUTHORIZE = 1,
    SPIN,
    ORDER,
    NAVIGATE_TO_HOME,
    NAVIGATE_TO_WHEEL,
    BUY_SPINS
}

export interface WheelConfig {
    header: WheelDynamicText;
    description?: WheelDynamicText;
    subtitle?: WheelDynamicText;
    buttons: WheelButtonConfig[]
}

export interface WheelButtonConfig extends WheelDynamicText {
    action: WheelAction;
    icon?: string;
    type?:'primary' | 'secondary'
}


export interface WheelUserState {
    spins: number;
    bonuses: number;
}

export interface WheelSpinResponse {
    days: number;
    reward: WheelSegment;
}

export interface WheelGenericResponse <T> {
    success: boolean;
    data?:T
}

export interface WheelSegment {
    type: 'bonuses' | 'product'| 'spins',
    position: number,
    reward:WheelProductReward |WheelBonusReward | WheelSpinReward
}

export interface WheelProductReward {
    bonuses: null;
    product: {
        id: number;
        name: string;
        img: string;
        cat_id: number;
        category_img: string;
    };
    spins: null;
}

export interface WheelBonusReward {
    bonuses: string;
    product: null;
    spins: null;
}

export interface WheelSpinReward {
    bonuses: null;
    product: null;
    spins: number;
}

export interface WheelDynamicText {
    text?: string;
    html?: string;
    translateKeyValuePairs: {
        [prop:string]:string | number
    },
    classes: string[];
}

export interface WheelPrize {
    type:'bonuses'|'product'|'spins',
    img: string,
    name:number|string,
    days:number
}

export interface WheelBonus {
    price: number;
    spins: number;
    old_price: null | number;
    discount: null | number;
}
